//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/NXObject.js";
import "../no/Sketch.js";
let d=[[[0,"IsIgnored",0,0],[0,"IssueType",0,0]],[[[],"IgnoreIssue",{},0,0],[["numGeometries"],"GetGeometry",{R_:{geometries:""}},0,0]],[]];
SPLM.SketchIssue = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchIssue";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.SketchIssue.Type = Object.freeze({
    "AlmostHorizontal" : "AlmostHorizontal", "AlmostConnected" : "AlmostConnected", "AlmostTangent" : "AlmostTangent", "AlmostTangentAtVertex" : "AlmostTangentAtVertex", "AlmostParallel" : "AlmostParallel", "Overlapping" : "Overlapping", "TinyCurve" : "TinyCurve", "AlmostConcentric" : "AlmostConcentric", "AlmostEqualRadius" : "AlmostEqualRadius", "AlmostEqualLength" : "AlmostEqualLength", "AlmostPerpendicular" : "AlmostPerpendicular", "AlmostCollinear" : "AlmostCollinear", "AlmostPointOnCurve" : "AlmostPointOnCurve", "AlmostVertical" : "AlmostVertical"});

export default SPLM;